"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectFormSummary = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectFormSummary = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectFormSummary, _super);
    function IkeObjectFormSummary() {
        var _this = _super.call(this) || this;
        _this.className = 'FormSummary';
        _this.actionName = 'form.summary';
        _this.cacheKeys['revision'] = true;
        return _this;
    }
    return IkeObjectFormSummary;
}(base_1.IkeRestObject));
exports.IkeObjectFormSummary = IkeObjectFormSummary;
//# sourceMappingURL=form.summary.object.js.map